import Skeleton from "@mui/material/Skeleton";
import React from "react";
import "../../dashboard-layout/_footer/Footer.scss";

const Footer = (props) => {
  const { siteSettingData, isLoading } = props;

  const data = {
    copy: (siteSettingData || "").copyright_text,
  };

  return (
    <footer>
      <div className="footer-full footer-auth">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="foot-cnt">
                {data.copy !== undefined ? (
                  isLoading ? (
                    <div className="copy">
                      <Skeleton animation="wave" width={100} />
                    </div>
                  ) : (
                    <div
                      className="copy"
                      dangerouslySetInnerHTML={{ __html: `<span>${data.copy}</span>` }}
                    />
                  )
                ) : null}
                <div className="version">
                  {(siteSettingData || "").show_version && (
                    <span>
                      <a
                        className="version__history"
                        href={`${(siteSettingData || "").version_link}`}
                        target="__blank"
                      >
                        {(siteSettingData || "").version_text}
                      </a>
                    </span>
                  )}
                  {(siteSettingData || "").show_lastupdate && (
                    <span>{(siteSettingData || "").lastupdate_text}</span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
